var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "py-3 px-3 min-w-60 flex flex-col gap-3 bg-pure-white rounded border border-slate-400"
    },
    [
      _c(
        "div",
        { staticClass: "flex items-center justify-between gap-2" },
        [
          _c("BlTextBody2", { attrs: { text: _vm.title } }),
          _vm._v(" "),
          _vm.title === "Scheduled sessions"
            ? _c(
                "div",
                {
                  staticClass:
                    "px-2 h-6 flex items-center gap-2 rounded-full cursor-pointer",
                  style: { backgroundColor: "#F4F3FF" },
                  on: {
                    click: function($event) {
                      _vm.rescheduledSwitch =
                        _vm.rescheduledSwitch === "session"
                          ? "credit"
                          : "session"
                    }
                  }
                },
                [
                  _c("BlIcon", {
                    staticClass: "h-4 w-4",
                    attrs: { icon: "swap" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody3", {
                    staticClass: "text-light-purple capitalize",
                    attrs: {
                      text:
                        (_vm.rescheduledSwitch === "session"
                          ? "credit"
                          : "session") + "s"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center justify-between gap-3 truncate" },
        [
          _vm.title === "Current balance"
            ? _c(
                "div",
                { staticClass: "flex gap-2" },
                [
                  _c("BlTextSubtitle1", {
                    staticClass: "text-slate-500",
                    attrs: { text: _vm.currentCenter.currency_sym }
                  }),
                  _vm._v(" "),
                  _c("BlTextTitle3", {
                    class: [
                      _vm.currentBalance < 0
                        ? "text-red-cherry"
                        : "text-dark-purple-100"
                    ],
                    attrs: { text: _vm.priceFormats(_vm.currentBalance) }
                  })
                ],
                1
              )
            : _vm.title === "Scheduled sessions"
            ? _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _vm.rescheduledSwitch === "session"
                    ? _c("BlTextTitle3", {
                        class: [
                          _vm.totalSessions < 0
                            ? "text-red-cherry"
                            : "text-dark-purple-100"
                        ],
                        attrs: { text: _vm.totalSessions || 0 }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rescheduledSwitch === "credit"
                    ? _c("BlTextTitle3", {
                        class: [
                          _vm.totalCredits < 0
                            ? "text-red-cherry"
                            : "text-dark-purple-100"
                        ],
                        attrs: { text: _vm.totalCredits || 0 }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("BlTextBody3", {
                    staticClass: "text-slate-600 truncate",
                    attrs: { text: _vm.rescheduledSwitch + "(s)" }
                  })
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "flex items-center gap-2 truncate" },
                [
                  _c("BlTextTitle3", {
                    staticClass: "text-lime-500",
                    attrs: { text: _vm.totalAvailableCredits }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody3", {
                    staticClass: "text-slate-600 truncate",
                    attrs: { text: "credit(s)" }
                  })
                ],
                1
              ),
          _vm._v(" "),
          _vm.usePanel
            ? _c(
                "div",
                [
                  _c("BlInputButton", {
                    staticClass: "w-7 h-7 bg-slate-200 rounded-full",
                    attrs: {
                      type: "outlined",
                      icon: "chevron-right",
                      dense: ""
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("open-panel")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-932366d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-932366d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/creditTransaction/CreditDetails.vue
// module id = null
// module chunks = 